import { ThemeEvents } from '@theme/events';

const SELECTOR = '[data-free-shipping-bar]';
const CELEBRATE_CLASS = 'is-celebrating';
const CARD_ANIMATION = 'fsb-card-pop';

/** @type {number | null} */
let lastProgress = null;

/**
 * @param {HTMLElement} el
 * @returns {number}
 */
function readProgress(el) {
  const value = parseFloat(el.dataset.progress ?? '0');
  return Number.isFinite(value) ? value : 0;
}

/**
 * @param {HTMLElement} bar
 */
function startCelebrate(bar) {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  bar.classList.remove(CELEBRATE_CLASS);
  // Force reflow so replay works if they unlock again in the same session
  void bar.offsetWidth;
  bar.classList.add(CELEBRATE_CLASS);

  const onEnd = (event) => {
    if (!(event instanceof AnimationEvent)) return;
    if (event.animationName !== CARD_ANIMATION) return;
    bar.classList.remove(CELEBRATE_CLASS);
    bar.removeEventListener('animationend', onEnd);
  };

  bar.addEventListener('animationend', onEnd);
}

function tryCelebrate() {
  const bars = document.querySelectorAll(`${SELECTOR}[data-celebrate="true"]`);

  if (!bars.length) {
    lastProgress = 0;
    return;
  }

  let nextProgress = lastProgress;

  bars.forEach((node) => {
    if (!(node instanceof HTMLElement)) return;

    const progress = readProgress(node);
    const unlocked =
      node.classList.contains('free-shipping-bar--unlocked') || progress >= 1;
    const crossed = lastProgress !== null && lastProgress < 1 && unlocked;

    if (crossed) {
      startCelebrate(node);
    }

    nextProgress = progress;
  });

  lastProgress = nextProgress;
}

function scheduleCheck() {
  // cart:update often fires before morph finishes; wait until after layout/paint
  requestAnimationFrame(() => {
    requestAnimationFrame(tryCelebrate);
  });
}

function initProgressBaseline() {
  const bar = document.querySelector(`${SELECTOR}[data-celebrate="true"]`);
  if (bar instanceof HTMLElement) {
    lastProgress = readProgress(bar);
  }
}

document.addEventListener(ThemeEvents.cartUpdate, scheduleCheck);
document.addEventListener('DOMContentLoaded', initProgressBaseline);

if (document.readyState !== 'loading') {
  initProgressBaseline();
}
